// Reducer Functions
export const filterClick = (state, action) => {
  const newFilters = Object.assign({}, state.filters);
  const newSelectedFilters = Object.assign({}, state.selectedFilters);
  let newSelectedFilterArray = [];

  Object.keys(newFilters).map((filterKey) => {
    if (typeof newFilters[filterKey] !== 'string') {
      newFilters[filterKey].options.map((optionItem) => {
        if (action.option.type === 'radio') {
          if (action.option.name === optionItem.name) {
            optionItem.isChecked = true;
            newSelectedFilters[filterKey] = (action.option.name === 'All' ? [] : [action.option.name]);
          } else {
            optionItem.isChecked = false;
          }
        }

        if (action.option.type === 'checkbox') {
          if (action.option.isChecked === false && action.option.name === optionItem.name) {
            optionItem.isChecked = true;
            newSelectedFilterArray = newSelectedFilters[filterKey].concat(action.option.name);
            newSelectedFilters[filterKey] = newSelectedFilterArray;
          } else if (action.option.isChecked === true && action.option.name === optionItem.name) {
            optionItem.isChecked = false;
            newSelectedFilterArray = newSelectedFilters[filterKey].filter(key => key !== action.option.name);
            newSelectedFilters[filterKey] = newSelectedFilterArray;
          } else {
            return false;
          }
        }
        return false;
      });
    }
    return false;
  });

  return {
    filters: newFilters,
    selectedFilters: newSelectedFilters,
  };
};

export const clearFilters = (state) => {
  const newFilters = Object.assign({}, state.filters);
  const newSelectedFilters = Object.assign({}, state.selectedFilters);

  Object.keys(newFilters).map((filterKey) => {
    if (typeof newFilters[filterKey] !== 'string') {
      newFilters[filterKey].options.map((optionItem) => {
        if (optionItem.type === 'radio' && optionItem.value === 'All') {
          optionItem.isChecked = true;
        } else {
          optionItem.isChecked = false;
        }
        return false;
      });
    }
    return false;
  });

  Object.keys(newSelectedFilters).map((filterKey) => {
    newSelectedFilters[filterKey] = [];
    return false;
  });

  return {
    filters: newFilters,
    selectedFilters: newSelectedFilters,
  };
};

export const filterArticleItems = (articleItems, state) => {
  const newArticleItems = articleItems.filter(item => (
    (state.selectedFilters.categoryFilter.length === 0 || state.selectedFilters.categoryFilter.some(filter => item.articleCategories.some(category => category.name === filter)))
  ));

  return {
    filters: state.filters,
    selectedFilters: state.selectedFilters,
    articleItems: newArticleItems,
  };
};

export const getPager = (totalItems, currentPage, pageSize) => {
  /* eslint-disable no-param-reassign */
  // default to first page
  currentPage = currentPage || 1;

  // default page size is 10
  pageSize = pageSize || 12;
  /* eslint-enable no-param-reassign */

  // calculate total pages
  const totalPages = Math.ceil(totalItems / pageSize);

  let startPage;
  let endPage;

  if (totalPages > 5) {
    // more than 10 total pages so calculate start and end pages
    if (currentPage <= 3) {
      startPage = 1;
      endPage = 5;
    } else if (currentPage + 2 >= totalPages) {
      startPage = totalPages - 4;
      endPage = totalPages;
    } else {
      startPage = currentPage - 3;
      endPage = currentPage + 2;
    }
  } else {
    // less than 10 total pages so show all
    startPage = 1;
    endPage = totalPages;
  }

  // calculate start and end item indexes
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min((startIndex + pageSize) - 1, totalItems - 1);

  // create an array of pages to ng-repeat in the pager control
  const pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);

  // return object with all pager properties required by the view
  return {
    totalItems,
    currentPage,
    pageSize,
    totalPages,
    startPage,
    endPage,
    startIndex,
    endIndex,
    pages,
  };
};

export const setPage = (state, action) => {
  const newPageOfItems = [].concat(state.pageOfItems);
  const newPager = Object.assign({}, state.pager);

  if (action.page < 1 || action.page > state.pager.totalPages) {
    return {
      pageOfItems: newPageOfItems,
      pager: newPager,
    };
  }

  // get new pager object for specified page
  const pager = getPager(state.mediaItems.length, action.page, state.pageSize);

  // get new page of mediaItems from mediaItems array
  const pageOfItems = state.mediaItems.slice(pager.startIndex, pager.endIndex + 1);

  // update state
  return {
    pageOfItems,
    pager,
  };
};
